import { ActionTypes } from "../constants/action-types";

const initialState = {
    registrationOnlineclass: [],
};

const fetchRegistration = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_REGISTRATION:
      return {
        ...state,
        registrationOnlineclass: action.payload,
      };

    default:
      return state;
  }
};

export default fetchRegistration;